import {Component, Inject} from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
    selector: 'print-dialog',
    templateUrl: 'print-dialog.component.html',
    styleUrls: ['./print-dialog.component.scss']
})
export class PrintDialog {
  result: any = {
      printType : 'complet'
  };
  constructor(
      public dialogRef: MatDialogRef<PrintDialog>,
      @Inject(MAT_DIALOG_DATA) public data: any
  ) { }
}